import gql from 'graphql-tag';
import { CERTIFICATION_RECORD_ATTACHMENT_FRAGMENT } from './certification-record-attachment-fragments';

export const CERTIFICATION_RECORD_FRAGMENT = gql`
  fragment CertificationRecord on CertificationRecord {
    id
    memberId
    certificationId
    issuedOn
    renewedOn
    expiresOn
    createdOn
    updatedOn
    member {
      id
      firstName
      lastName
    }
    certification {
      id
      name
      renewalPeriodMonths
      documentationRequired
    }
    attachments {
      ...CertificationRecordAttachment
    }
  }
  ${CERTIFICATION_RECORD_ATTACHMENT_FRAGMENT}
`;
